function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M357.6,335.1l28.4-28.4c4.4-4.4,12.2-1.3,12.2,5.1v129.2c0,23.6-19.1,42.7-42.7,42.7H42.7C19.1,483.6,0,464.5,0,440.9V128 c0-23.6,19.1-42.7,42.7-42.7h243.1c6.3,0,9.5,7.6,5.1,12.2L262.4,126c-1.3,1.3-3.1,2-5.1,2H42.7v312.9h312.9V340 C355.6,338.2,356.3,336.4,357.6,335.1z M496.8,155.7L263.4,389.1L183,398c-23.3,2.6-43.1-17.1-40.5-40.5l8.9-80.4L384.8,43.7 c20.4-20.4,53.2-20.4,73.5,0l38.4,38.4C517.1,102.4,517.1,135.4,496.8,155.7L496.8,155.7z M409,183.1l-51.6-51.6L192.2,296.7 l-6.5,58l58-6.5L409,183.1z M466.6,112.3l-38.4-38.4c-3.6-3.6-9.6-3.6-13.2,0l-27.5,27.5l51.6,51.6l27.5-27.5 C470.2,121.8,470.2,115.9,466.6,112.3z"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.79aaa740.svg";
export { ForwardRef as ReactComponent };